// General title relevance, independent of model names or stock status.
function misbhvSearchWords(value) {
  return String(value || '').normalize('NFKD').replace(/\p{M}/gu, '')
    .toLocaleLowerCase().match(/[\p{L}\p{N}]+/gu) || [];
}
function misbhvSearchTitleScore(title, query) {
  const words = misbhvSearchWords(title);
  const terms = misbhvSearchWords(query);
  if (!terms.length) return 0;
  if (words.join(' ') === terms.join(' ')) return 5000;
  const exact = terms.filter(term => words.includes(term)).length;
  if (exact === terms.length) return 4000;
  // Only the final word can be incomplete while the customer is typing.
  const prefixMatch = terms.every((term, index) => words.some(word =>
    word === term || (index === terms.length - 1 && term.length >= 2 && word.startsWith(term))));
  if (prefixMatch) return 3000;
  return exact ? 1000 + exact / terms.length : 0;
}
function misbhvRankSearch(items, query, titleOf) {
  return items.map((item, index) => ({item, index, score: misbhvSearchTitleScore(titleOf(item), query)}))
    .sort((a, b) => b.score - a.score || a.index - b.index).map(entry => entry.item);
}
function misbhvRankSearchGrid(container, query, sortBy) {
  if (sortBy && sortBy !== 'relevance') return;
  const list = container.querySelector('#product-grid');
  if (!list) return;
  const cards = Array.from(list.children).filter(node => node.tagName === 'LI' && node.querySelector('.card__title'));
  const ranked = misbhvRankSearch(cards, query, card => card.querySelector('.card__title').textContent);
  if (ranked.every((card, index) => card === cards[index])) return;
  // Preserve toolbar, pagination and all existing card nodes/event listeners.
  const slots = cards.map(card => {
    const slot = document.createComment('search-product');
    card.replaceWith(slot);
    return slot;
  });
  slots.forEach((slot, index) => slot.replaceWith(ranked[index]));
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-misbhv-v4-search]").forEach((search) => {
    const toggle = search.querySelector("[data-misbhv-v4-search-toggle]");
    const close = search.querySelector("[data-misbhv-v4-search-close]");
    const field = search.querySelector("[data-misbhv-v4-search-field]");

    if (!toggle || !close || !field) return;


    const panel = search.querySelector('[data-search-suggestions]');
    const results = panel?.querySelector('[data-search-products]');
    const status = panel?.querySelector('[data-search-status]');
    const form = search.querySelector('form');
    const unavailable = document.createElement('input');
    unavailable.type = 'hidden';
    unavailable.name = 'options[unavailable_products]';
    unavailable.value = 'show';
    form?.append(unavailable);
    let timer;
    let controller;
    let revision = 0;
    let composing = false;
    const resetSuggestions = () => {
      clearTimeout(timer);
      controller?.abort();
      revision++;
      if (!panel) return;
      panel.hidden = true;
      panel.removeAttribute('aria-busy');
      results.replaceChildren();
      status.textContent = '';
    };
    const make = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = 'misbhv-search-suggestions__' + className;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    const safeURL = (value, localOnly = false) => {
      if (!value) return null;
      const url = new URL(value, location.origin);
      if (!['https:', 'http:'].includes(url.protocol)) return null;
      if (localOnly && url.origin !== location.origin) return null;
      return url.href;
    };
    const renderProducts = (products, term) => {
      const list = make('ul', 'list');
      list.setAttribute('aria-label', panel.dataset.count);
      const seen = new Set();
      const currency = new Intl.NumberFormat(panel.dataset.locale || 'en', {
        style: 'currency', currency: panel.dataset.currency || 'USD'
      });
      for (const product of products) {
        if (seen.has(product.id)) continue;
        const href = safeURL(product.url, true);
        if (!href) continue;
        seen.add(product.id);
        const item = make('li');
        const link = make('a', 'product');
        link.href = href;
        const imageBox = make('span', 'image');
        const imageURL = safeURL(product.featured_image?.url || product.image);
        if (imageURL) {
          const img = make('img');
          const sized = new URL(imageURL);
          sized.searchParams.set('width', '180');
          img.src = sized.href;
          img.alt = '';
          img.width = 72;
          img.height = 90;
          img.loading = 'lazy';
          imageBox.append(img);
        }
        const details = make('span', 'details');
        details.append(make('span', '', product.title));
        if (product.price != null && Number.isFinite(Number(product.price))) {
          details.append(make('span', 'price', currency.format(Number(product.price))));
        }
        if (product.available === false) details.append(make('span', '', panel.dataset.sold));
        link.append(imageBox, details);
        item.append(link);
        list.append(item);
      }
      results.replaceChildren();
      if (seen.size) results.append(list);
      else results.append(make('p', 'empty', panel.dataset.empty));
      const all = make('a', 'all', panel.dataset.all);
      const target = new URL(form.action, location.origin);
      target.searchParams.set('q', term);
      target.searchParams.set('type', 'product');
      target.searchParams.set('options[unavailable_products]', 'show');
      all.href = target.href;
      results.append(all);
      status.textContent = seen.size ? panel.dataset.count + ': ' + seen.size : panel.dataset.empty;
    };
    const updateSuggestions = () => {
      resetSuggestions();
      const term = field.value.trim();
      if (!panel || composing || term.length < 2 || !search.classList.contains('is-open')) return;
      const requestRevision = revision;
      timer = setTimeout(async () => {
        controller = new AbortController();
        panel.hidden = false;
        panel.setAttribute('aria-busy', 'true');
        status.textContent = panel.dataset.loading;
        try {
          const url = new URL(panel.dataset.url, location.origin);
          url.pathname = url.pathname.replace(/\.json$/, '') + '.json';
          url.searchParams.set('q', term);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '10');
          url.searchParams.set('resources[options][unavailable_products]', 'show');
          const response = await fetch(url.href, {signal: controller.signal, headers: {Accept: 'application/json'}});
          if (!response.ok) throw new Error('Search unavailable');
          const data = await response.json();
          if (requestRevision !== revision) return;
          const products = data.resources?.results?.products;
          if (!Array.isArray(products)) throw new Error('Invalid search response');
          const unique = products.filter((product, index, all) =>
            all.findIndex(other => other.id === product.id) === index);
          renderProducts(misbhvRankSearch(unique, term, product => product.title).slice(0, 6), term);
        } catch (error) {
          if (requestRevision !== revision || error.name === 'AbortError') return;
          results.replaceChildren();
          status.textContent = panel.dataset.error;
        } finally {
          if (requestRevision === revision) panel.removeAttribute('aria-busy');
        }
      }, 200);
    };
    field.addEventListener('input', updateSuggestions);
    field.addEventListener('compositionstart', () => { composing = true; resetSuggestions(); });
    field.addEventListener('compositionend', () => { composing = false; updateSuggestions(); });
    form?.addEventListener('submit', (event) => {
      if (!field.value.trim()) event.preventDefault();
    });
    search.addEventListener('keydown', (event) => {
      if (!panel || panel.hidden || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
      const links = Array.from(results.querySelectorAll('a'));
      if (!links.length) return;
      const index = links.indexOf(document.activeElement);
      if (document.activeElement !== field && index === -1) return;
      event.preventDefault();
      if (event.key === 'ArrowDown') links[(index + 1) % links.length].focus();
      else if (index <= 0) field.focus();
      else links[index - 1].focus();
    });

    const setOpen = (isOpen) => {
      search.classList.toggle("is-open", isOpen);
      document.body.classList.toggle("misbhv-search-open", isOpen);
      toggle.setAttribute("aria-expanded", String(isOpen));

      if (isOpen) {
        window.requestAnimationFrame(() => field.focus());
        updateSuggestions();
      } else {
        resetSuggestions();
        toggle.focus();
      }
    };

    toggle.addEventListener("click", () => setOpen(true));
    close.addEventListener("click", () => setOpen(false));
    search.addEventListener("click", (event) => {
      if (event.target === search) setOpen(false);
    });

    search.addEventListener("keydown", (event) => {
      if (event.key === "Escape") setOpen(false);
    });
  });

  const localePanel = document.querySelector(".wt-lang");
  const localeOverlay = document.querySelector(".wt-lang__overlay");
  const localeClose = document.querySelector(".wt-lang .close-btn");

  if (localePanel) {
    const setLocaleOpen = (isOpen) => {
      localePanel.toggleAttribute("open", isOpen);
      document.body.classList.toggle("page-overlay-drawer-on", isOpen);
    };

    document.querySelectorAll("[toggle-localization-drawer]").forEach((trigger) => {
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        setLocaleOpen(true);
      });
    });

    localeClose?.addEventListener("click", () => setLocaleOpen(false));
    localeOverlay?.addEventListener("click", () => setLocaleOpen(false));

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && localePanel.hasAttribute("open")) {
        setLocaleOpen(false);
      }
    });
  }

  const navigationDrawer = document.querySelector("#MisbhvV3Menu");
  const navigationClose = navigationDrawer?.querySelector(".wt-drawer__close");

  if (navigationDrawer && navigationClose) {
    navigationDrawer.addEventListener("click", (event) => {
      if (!document.body.classList.contains("menu-open")) return;

      const interactiveElement = event.target.closest(
        "a, button, input, select, textarea, summary, [role='button']",
      );

      const navigationContent = event.target.closest(
        ".beta-nav-v2__column, .beta-nav-v2__mobile-tree, .misbhv-v3-menu__support",
      );

      if (interactiveElement || navigationContent) return;

      navigationClose.click();
    });
  }
});

// Live full results: preserve the input node, render Shopify's existing product cards.
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.collection__header--search');
  const form = header?.querySelector('form[role="search"]');
  const field = form?.querySelector('input[name="q"]');
  const section = header?.closest('[data-section-id]');
  const grid = section?.querySelector('#ProductGridContainer');
  if (!field || !section || !grid) return;
  section.classList.add('misbhv-live-search');
  const polish = document.documentElement.lang.startsWith('pl');
  const status = document.createElement('p');
  status.className = 'misbhv-live-search__status';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  header.append(status);
  // Keep an accessible name when the old magnifying-glass label is hidden.
  field.setAttribute('aria-label', polish ? 'Szukaj produktów' : 'Search products');
  field.placeholder = polish ? 'Szukaj' : 'Search';
  field.setAttribute('autocomplete', 'off');
  const submit = document.createElement('button');
  submit.type = 'submit';
  submit.className = 'misbhv-live-search__submit';
  submit.textContent = polish ? 'Szukaj' : 'Go';
  form.querySelector('fieldset').append(submit);
  let timer;
  let controller;
  let revision = 0;
  let composing = false;
  const cancel = () => {
    clearTimeout(timer);
    controller?.abort();
    revision++;
    grid.removeAttribute('aria-busy');
  };
  const requestURL = () => {
    const url = new URL(form.action, location.origin);
    // Keep market/preview parameters; reset pagination and filters for a new phrase.
    const current = new URL(location.href);
    for (const [key, value] of current.searchParams) {
      if (['preview_theme_id', '_fd', 'pb', 'country', 'currency'].includes(key)) url.searchParams.set(key, value);
    }
    for (const [key, value] of new FormData(form)) url.searchParams.set(key, value);
    url.searchParams.set('q', field.value.trim());
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[unavailable_products]', 'show');
    return url;
  };
  const refresh = async () => {
    const token = revision;
    const url = requestURL();
    const requestController = new AbortController();
    controller = requestController;
    const timeout = setTimeout(() => requestController.abort(), 15000);
    grid.setAttribute('aria-busy', 'true');
    status.textContent = polish ? 'Wyszukiwanie…' : 'Searching…';
    try {
      const response = await fetch(url.href, {signal: controller.signal});
      if (!response.ok) throw new Error('Search unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (token !== revision) return;
      const nextGrid = doc.querySelector('#ProductGridContainer');
      const nextTitle = doc.querySelector('.search-results__title');
      if (!nextGrid || !nextTitle) throw new Error('Missing search results');
      misbhvRankSearchGrid(nextGrid, url.searchParams.get('q'), url.searchParams.get('sort_by'));
      grid.replaceChildren(...Array.from(nextGrid.childNodes));
      const title = header.querySelector('.search-results__title');
      if (title) title.replaceChildren(...Array.from(nextTitle.childNodes));
      const nextAside = doc.querySelector('.collection__aside.wt-filter');
      const aside = section.querySelector('.collection__aside.wt-filter');
      if (aside && nextAside) {
        aside.replaceChildren(...Array.from(nextAside.childNodes));
        const collection = section.querySelector('collection-section');
        aside.querySelectorAll('.wt-filter__close').forEach(button => {
          button.addEventListener('click', event => collection?.toggleDrawer(event));
        });
      }
      // Newly inserted result cards must not wait for the theme's initial scroll observer.
      grid.querySelectorAll('.scroll-trigger').forEach(node => {
        node.classList.remove('scroll-trigger', 'scroll-trigger--offscreen');
      });
      history.replaceState({...history.state, searchParams: url.searchParams.toString()}, '', url.href);
      if (typeof FacetFiltersForm !== 'undefined') {
        FacetFiltersForm.searchParamsPrev = url.searchParams.toString();
      }
      document.title = doc.title || document.title;
      status.textContent = field.value.trim()
        ? (polish ? 'Wyniki zaktualizowane.' : 'Results updated.')
        : (polish ? 'Wpisz nazwę produktu.' : 'Enter a product name.');
    } catch (error) {
      if (token !== revision) return;
      status.textContent = polish
        ? 'Nie udało się odświeżyć wyników. Naciśnij Enter, aby spróbować ponownie.'
        : 'Could not update results. Press Enter to retry.';
    } finally {
      clearTimeout(timeout);
      if (token === revision) grid.removeAttribute('aria-busy');
    }
  };
  const schedule = () => {
    cancel();
    if (composing) return;
    status.textContent = polish ? 'Wyszukiwanie…' : 'Searching…';
    timer = setTimeout(refresh, 300);
  };
  field.addEventListener('input', schedule);
  field.addEventListener('compositionstart', () => { composing = true; cancel(); });
  field.addEventListener('compositionend', () => { composing = false; schedule(); });
  form.addEventListener('submit', event => {
    event.preventDefault();
    cancel();
    refresh();
  });
  window.addEventListener('pagehide', cancel);
  const initialURL = new URL(location.href);
  misbhvRankSearchGrid(grid, field.value, initialURL.searchParams.get('sort_by'));
  if (field.value.trim() && initialURL.searchParams.get('options[unavailable_products]') !== 'show') refresh();
});
